import React from 'react';

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="-17 3 14 14">
		<polygon points="-3,4.7 -4.7,3 -10,8.3 -15.3,3 -17,4.7 -11.7,10 -17,15.3 -15.3,17 -10,11.7 -4.7,17 -3,15.3	-8.3,10 "/>
	</svg>
)
